/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Was ein Klick auf den Baustein ausloest.
 * 
 *   NONE         — nichts.
 *   LINK         — der Ziel-Link des Bausteins.
 *   POPUP        — der im Baustein hinterlegte Popup-Inhalt.
 *   POPUP_FELD   — NUR BEIM BANNER: der Popup-Text kommt aus einem
 *                  DATENFELD der Unterdatenbank (`popupFeldId`), also je
 *                  Datensatz ein anderer. Vorgabe des Betreibers vom
 *                  14.09.2026: „Popup-Text muesste zum Reiter Aktion.
 *                  Dieser Aktionstyp sollte ergaenzt werden, wenn es
 *                  sich um ein Banner handelt."
 *   LINK_FELD    — NUR BEIM BANNER: das Ziel steht in einem DATENFELD der
 *                  Unterdatenbank (`linkFeldId`), also je Datensatz ein
 *                  anderes. Gegenstueck zu POPUP_FELD; Vorgabe des
 *                  Betreibers vom 15.09.2026: „Der Verweis muss weg ..
 *                  dafuer gibt es Aktion als Reiter".
 *   CLOSING_PAGE — die Abschlussseite.
 * @export
 */
export const DatabaseHeaderBlockActionType = {
    None: 'NONE',
    Link: 'LINK',
    Popup: 'POPUP',
    PopupFeld: 'POPUP_FELD',
    LinkFeld: 'LINK_FELD',
    ClosingPage: 'CLOSING_PAGE'
} as const;
export type DatabaseHeaderBlockActionType = typeof DatabaseHeaderBlockActionType[keyof typeof DatabaseHeaderBlockActionType];


export function DatabaseHeaderBlockActionTypeFromJSON(json: any): DatabaseHeaderBlockActionType {
    return DatabaseHeaderBlockActionTypeFromJSONTyped(json, false);
}

export function DatabaseHeaderBlockActionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseHeaderBlockActionType {
    return json as DatabaseHeaderBlockActionType;
}

export function DatabaseHeaderBlockActionTypeToJSON(value?: DatabaseHeaderBlockActionType | null): any {
    return value as any;
}

